import { DataProvider } from 'react-admin'
import { FilePathDto } from '../../dto/files/FilesPath.dto'

const fakeFiles: FilePathDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeFiles, total: fakeFiles.length }),
} as DataProvider

export default provider
